import { GenericObject, LoggerFactory, Loggers } from 'moleculer';
import winston from 'winston';

import Logger from './logger';

export class MoleculerLogger extends Loggers.Base {
  logger: winston.Logger;

  level: string;

  init(loggerFactory: LoggerFactory) {
    super.init(loggerFactory);
    this.logger = Logger.instance.getLogger();
  }

  getLogHandler = (bindings: GenericObject) => {
    const level = bindings ? this.getLogLevel(bindings.mod as string) : null;

    if (!level) return null;

    return (type: string, args: unknown[]) => {
      const [msg, ...rest] = [...(args || []), bindings.mod] || [];

      const params = {
        message: msg as unknown,
        ...rest,
      };

      switch (type) {
        case 'error':
          return this.logger.error(params);
        case 'warn':
          return this.logger.warn(params);
        case 'log':
          return this.logger.log(level, params);
        case 'verbose':
          return this.logger.verbose(params);
        case 'debug':
          return this.logger.debug(params);
        default:
          return this.logger.log(level, params);
      }
    };
  };
}
